<script>
export default {
  props: {
    validacoesSucesso: Boolean,
    message: String,
  },
};
</script>
<template>
  <CAlert
    color="success"
    id="sucesso"
    name="sucesso"
    :show.sync="validacoesSucesso"
    closeButton
    >{{ message }}</CAlert
  >
</template>
<style scoped></style>
